<template>
  <div class="chat-input px-2">
    <form
      class="row align-items-center no-gutters"
      @submit.prevent="submit"
      v-if="isActive"
    >
      <div class="col">
        <input
          name="msg"
          type="text"
          v-model="msg"
          @focus="refreshHeight"
          @blur="refreshHeight"
          @keyup.enter="submit"
        />
      </div>
      <div class="col-auto overflow-hidden">
        <label :class="{'text-muted': file}">
          <input type="file" @change="handleFileChange" />
          <UploadIcon></UploadIcon>
        </label>
      </div>
      <div class="col-auto overflow-hidden">
        <button type="submit" @click="submit">
          <SendIcon></SendIcon>
        </button>
      </div>
      <div class="col-auto overflow-hidden">
        <button
          type="button"
          @click.prevent="completeChat"
          v-if="authType === 'ClinicOperator'"
        >
          <CloseIcon></CloseIcon>
        </button>
      </div>
    </form>
    <div v-else-if="authType === 'Patient'">
      <router-link
        v-if="chat.type == 'PatientDoctor'"
        to="/doctors"
        class="contact"
      >
        {{ $t("contactDoctor") }}
      </router-link>
      <router-link
        :to="`/clinics/0d174bf2-5ee4-4190-95f0-61e082e75f34/inquiry`"
        v-else-if="chat.type == 'PatientClinic'"
        class="contact"
      >
        {{ $t("contactClinic") }}
      </router-link>
    </div>
    <div
      v-else-if="
        authType === 'ClinicOperator' &&
        chat.chat_space.last_clinic_inquiry.status == 'pending'
      "
    >
      <a @click.prevent="openChat" class="contact pointer">
        {{ $t("openChat") }}
      </a>
    </div>
    <div v-else-if="authType === 'ClinicOperator'">
      <a class="contact">
        {{ $t("chatIsInactive") }}
      </a>
    </div>
  </div>
</template>
<script>
import SendIcon from '@/components/Icons/Send'
import UploadIcon from '@/components/Icons/Upload'
import CloseIcon from '@/components/Icons/Close'
import { mapMutations, mapGetters, mapActions } from 'vuex'
export default {
  components: {
    SendIcon,
    UploadIcon,
    CloseIcon
  },
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      msg: '',
      file: null
    }
  },
  computed: {
    ...mapGetters({
      authType: 'auth/type',
      chatById: 'chat/byId',
      isActive: 'chat/isActive'
    }),
    chat () {
      return this.chatById(this.value)
    }
    // isActive () {
    //   if (this.chat.type === 'PatientDoctor') {
    //     if (this.chat.chat_space.active_until) {
    //       return (
    //         this.$moment(this.chat.chat_space.active_until).diff(
    //           this.$moment()
    //         ) > 0
    //       )
    //     }
    //   } else if (this.chat.type === 'PatientClinic' && this.authType !== 'Patient') {
    //     if (this.chat.chat_space.last_clinic_inquiry.status !== 'active') {
    //       return false
    //     }
    //   }
    //   return true
    // }
  },
  methods: {
    ...mapMutations({
      pushMessage: 'message/push',
      setError: 'alert/setError',
      setInquiry: 'chat/setInquiry',
      refreshHeight: 'app/refreshHeight'
    }),
    ...mapActions({
      sendMessage: 'chat/send',
      sendFile: 'chat/file'
    }),
    async handleFileChange (e) {
      this.file = e.target.files[0]
      this.msg = this.file.name
      // /api/chat-spaces/{chat_space_id: UUID}/messages/file
      // id: UUID
      // chat_space_ID: UUID
      // name: string
      // mime_type: PatientCaseFileMimeType
      // created_at: DateTime
      // created_by: UUID
    },
    async submit () {
      if (!this.msg) {
        return
      }
      if (
        this.chat &&
        this.chat.chat_space &&
        this.chat.chat_space.last_clinic_inquiry &&
        this.chat.chat_space.last_clinic_inquiry.status === 'completed'
      ) {
        try {
          const params = { clinic_id: this.chat.chat_space.clinic_id }
          const response = await this.axios.post(
            '/api/clinic-inquiries',
            params
          )
          this.setInquiry({ id: this.value, inquiry: response.data.data })
        } catch (err) {
          this.setError(err)
        }
      }
      const msg = this.msg
      this.msg = ''
      if (this.file) {
        this.sendFile({ id: this.value, msg: msg, file: this.file })
        this.file = null
      }
      this.sendMessage({ id: this.value, msg: msg })
    },
    async openChat () {
      try {
        const response = await this.axios.post(
          `/api/clinic-inquiries/${this.chat.chat_space.last_clinic_inquiry.id}/join`
        )
        const inquiry = response.data.data
        this.setInquiry({ id: this.value, inquiry: inquiry })
      } catch (err) {
        this.setError(err)
      }
    },
    async completeChat () {
      try {
        const response = await this.axios.post(
          `/api/clinic-inquiries/${this.chat.chat_space.last_clinic_inquiry.id}/complete`
        )
        const inquiry = response.data.data
        this.setInquiry({ id: this.value, inquiry: inquiry })
      } catch (err) {
        this.setError(err)
      }
    }
  }
}
</script>
<style lang="scss">
.chat-input {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 5px 0 8px 0;
  // box-shadow: 0 -1px 3px rgba(0, 0, 0, 0.12), 0 -1px 2px rgba(0, 0, 0, 0.24);
  .contact {
    display: block;
    padding: 7px;
    background-color: #eee;
    width: 100%;
    border-radius: 12px;
    border: 0;
    outline: none;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    font-family: SFProText, Helvetica;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    text-align: center;
    text-decoration: none;
  }
  form {
    height: 32px;
    background-color: #eee;
    width: 100%;
    border-radius: 12px;
    border: 0;
    outline: none;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    font-family: SFProText, Helvetica;
    font-weight: 600;
    font-size: 14px;
    line-height: 19px;
    input {
      padding: 0 16px;
      background: transparent;
      width: 100%;
      border: none;
      box-shadow: none;
      &:focus {
        border: none;
        box-shadow: none;
        outline: none;
      }
    }
    label {
      padding: 0px;
      color: #3c88ff;
      cursor: pointer;
      svg {
        padding-top: 10px;
        width: 16px;
      }
      input[type="file"] {
        display: none;
      }
    }
    button {
      display: block;
      border: 0;
      background: 0;
      padding: 0.25rem 0.25rem 0.25rem 0.4rem;
      // box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
      border-radius: 3rem;
      transition: all 0.2s linear;
      padding: 0 12px;
      color: #3c88ff;
      &:focus {
        border: none;
        box-shadow: none;
        outline: none;
      }
      svg {
        width: 16px;
      }
    }
  }
}
</style>
<i18n>
{
  "ka": {
      "contactDoctor": "დაუკავშირდი ექიმს",
      "contactClinic": "დაუკავშირდი კლინიკას",
      "openChat": "პასუხის გაცემა",
      "chatIsInactive": "ჩატი პასიურია"
  },
  "en": {
      "contactDoctor": "Contact Doctor",
      "contactClinic": "Contact Clinic",
      "openChat": "Open Chat",
      "chatIsInactive": "Chat is inactive"
  }
}
</i18n>
